/**
 * МегаМеню «Функции» — поведение как Radix NavigationMenu:
 * - Открытие по hover на десктопе (≥901px) с небольшой задержкой закрытия
 * - Клик по summary также работает (мобиль)
 * - Взаимное закрытие при открытии другого меню
 * - Закрытие по клику снаружи и клавишей Escape
 */
export default function mnrMegaMenu() {
    const megas = document.querySelectorAll(".mnr-mega");
    if (!megas.length) return;

    const DESKTOP_BP = 901;
    const CLOSE_DELAY = 120; // ms — даёт время переместить курсор на панель
    let closeTimer = null;

    megas.forEach((details) => {
        const wrap = details.closest(".mnr-nav-mega-wrap") || details;

        // ── Hover (только десктоп) ──────────────────────────────────────────
        wrap.addEventListener("mouseenter", () => {
            if (window.innerWidth < DESKTOP_BP) return;
            clearTimeout(closeTimer);
            details.setAttribute("open", "");
        });

        wrap.addEventListener("mouseleave", () => {
            if (window.innerWidth < DESKTOP_BP) return;
            closeTimer = setTimeout(() => {
                details.removeAttribute("open");
            }, CLOSE_DELAY);
        });

        // Если курсор вошёл в панель — отменяем закрытие
        const panel = details.querySelector(".mnr-mega-panel");
        if (panel) {
            panel.addEventListener("mouseenter", () => clearTimeout(closeTimer));
            panel.addEventListener("mouseleave", () => {
                if (window.innerWidth < DESKTOP_BP) return;
                closeTimer = setTimeout(() => {
                    details.removeAttribute("open");
                }, CLOSE_DELAY);
            });
        }

        // ── Взаимное закрытие ───────────────────────────────────────────────
        details.addEventListener("toggle", () => {
            if (!details.open) return;
            megas.forEach((other) => {
                if (other !== details) other.removeAttribute("open");
            });
        });
    });

    // ── Клик снаружи ───────────────────────────────────────────────────────
    document.addEventListener("click", (e) => {
        const t = e.target;
        if (!(t instanceof Node)) return;
        megas.forEach((details) => {
            if (details.open && !details.contains(t)) {
                details.removeAttribute("open");
            }
        });
    });

    // ── Escape ──────────────────────────────────────────────────────────────
    document.addEventListener("keydown", (e) => {
        if (e.key !== "Escape") return;
        megas.forEach((d) => d.removeAttribute("open"));
    });
}
